exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".booking-timer{align-items:center;justify-content:flex-start;background-color:#001d38;width:100%;padding:15px 20px;border-radius:15px}@media screen and (max-width:1550px){.booking-timer{margin-bottom:25px}}.booking-timer p,.booking-timer span{font-family:Avenir-Heavy;font-size:14px;color:#fff}.booking-timer p{margin-left:30px}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};